module.exports = __webpack_public_path__ + "img/airelibre.3132c844.png";